import React from 'react';
import PropTypes from 'prop-types';

import { useIntl } from 'react-intl';

import Button from 'app/components/Button';
import Popup from 'app/components/Popup';

import './ConfirmApiKeyChangeModal.scss';

export default function ConfirmApiKeyChangeModal({ show, setShow, onConfirm }) {
  const intl = useIntl();

  const handleClose = () => {
    setShow(false);
  };

  const handleConfirm = () => {
    onConfirm();
    handleClose();
  };

  return (
    <Popup
      show={show}
      header={
        <div className="bb-popup-confirm-api-key__header">
          <p className="bold">
            {intl.formatMessage({
              id: 'controlpanel.my_account.synchronize.api_key.confirm_change.title'
            })}
          </p>
        </div>
      }
      body={
        <div className="bb-popup-confirm-api-key__body">
          <p
            style={{ whiteSpace: 'pre-line' }}
            dangerouslySetInnerHTML={{
              __html: intl.formatMessage({
                id: 'controlpanel.my_account.synchronize.api_key.confirm_change.message'
              })
            }}
          />
        </div>
      }
      footer={
        <div className="bb-popup-confirm-api-key__footer">
          <Button
            text={intl.formatMessage({
              id: 'controlpanel.global.cancel'
            })}
            type="default"
            size="big"
            onClick={handleClose}
          />
          <Button
            text={intl.formatMessage({
              id: 'controlpanel.my_account.synchronize.api_key.confirm_change.confirm'
            })}
            type="primary"
            size="big"
            onClick={handleConfirm}
          />
        </div>
      }
      handleClose={handleClose}
    />
  );
}

ConfirmApiKeyChangeModal.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};
